import WithHighlight from 'components/WithHighlight';
import ActivityHeaderText from 'components/text/ActivityHeaderText';

import useTranslation from './hooks/useTranslation';

import { TEST_ID } from './constants';
import type { FunctionComponent, Props } from './types';

import styles from './styles.module.scss';

const ActivityCardHeader: FunctionComponent<Props> = ({
    className = '',
    date,
    testId = TEST_ID
}) => {
    const { FRIDAY, MONDAY, SATURDAY, SUNDAY, THURSDAY, TODAY, TUESDAY, WEDNESDAY } =
        useTranslation();

    const daysOfWeek = [SUNDAY, MONDAY, TUESDAY, WEDNESDAY, THURSDAY, FRIDAY, SATURDAY];

    const todaysDate = new Date().setHours(0, 0, 0, 0);
    const dateToCheck = new Date(date).setHours(0, 0, 0, 0);
    const isToday = dateToCheck === todaysDate;

    let headerText = '';

    if (isToday) {
        headerText = TODAY;
    } else {
        const dayOfWeek = daysOfWeek[date.getDay()].slice(0, 3);
        const dayOfMonth = date.getDate();

        headerText = `${dayOfWeek} ${dayOfMonth}`;
    }

    const headerClass = isToday ? styles.today : styles.dayOfWeek;

    return (
        <WithHighlight className={className} isEnabled={isToday}>
            <ActivityHeaderText className={headerClass} testId={testId} text={headerText} />
        </WithHighlight>
    );
};

export default ActivityCardHeader;
